module.exports = __webpack_public_path__ + "static/media/P_1.d08757f1.jpg";